const initState = {
  amount: null,
  id: null,
  wallet_log: [],
  loading: false,
  lastDocument: null,
  hasMoreDocument: true,
};
const walletReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_WALLET":
      return {
        ...state,
        amount: action.payload?.amount ?? null,
        id: action.payload?.id ?? null,
      };
    case "FETCH_WALLET_LOGS":
      return {
        ...state,
        wallet_log: action.payload.data,
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "FETCH_WALLET_LOGS_MORE":
      return {
        ...state,
        wallet_log: [...state.wallet_log, ...action.payload.data],
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "SET_IS_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default walletReducer;
